export const newChatDesign = {
  dialog:
    'p-0 gap-0 overflow-hidden max-w-[460px] border-gray-200 dark:border-neutral-800 shadow-xl dark:bg-neutral-900',

  header:
    'px-6 pt-6 pb-5 border-b border-gray-200 dark:border-neutral-800',

  title: 'text-lg font-semibold text-gray-950 dark:text-gray-100 leading-tight',
  subtitle: 'text-sm text-gray-500 dark:text-neutral-400 mt-1.5 leading-5',
  status:
    'mt-3 text-sm font-medium text-violet-700 dark:text-violet-300',

  body: 'px-6 pt-5 pb-3',

  selectedWrap: 'mb-4',
  selectedHeader: 'flex items-center justify-between mb-2.5',
  selectedLabel:
    'text-xs font-medium text-gray-600 dark:text-neutral-300',
  selectedCount: 'text-xs tabular-nums text-gray-500 dark:text-neutral-400',
  chip:
    'inline-flex items-center gap-2 rounded-md bg-gray-100 dark:bg-neutral-800 text-gray-700 dark:text-neutral-200 px-2.5 py-1.5 text-xs font-medium hover:bg-gray-200 dark:hover:bg-neutral-700 transition-colors',
  chipDisabled: 'opacity-70 cursor-not-allowed',

  searchWrap: 'mb-4',
  searchInput:
    'h-10 bg-white dark:bg-neutral-900 border-gray-300 dark:border-neutral-700 rounded-lg text-sm focus-visible:border-[#7C3AED] focus:border-[#7C3AED] shadow-none',

  listLabel:
    'text-xs font-medium text-gray-500 dark:text-neutral-400 mb-2',

  contactRow:
    'group flex items-center gap-3 px-3 py-2.5 cursor-pointer border-b border-gray-100 dark:border-neutral-800 last:border-b-0',
  contactRowHover: 'hover:bg-gray-50 dark:hover:bg-neutral-800/60',
  contactRowSelected:
    'bg-violet-50 dark:bg-violet-500/10',
  contactName: 'text-[13px] font-semibold text-gray-900 dark:text-gray-100 truncate',
  contactEmail: 'text-xs text-gray-500 dark:text-neutral-400 truncate',
  checkBadge:
    'w-5 h-5 rounded border border-[#7C3AED] bg-[#7C3AED] flex items-center justify-center flex-shrink-0 after:content-[\'\'] after:w-2 after:h-1 after:border-l-2 after:border-b-2 after:border-white after:-rotate-45 after:-translate-y-px',
  checkEmpty:
    'w-5 h-5 rounded border border-gray-300 dark:border-neutral-600 flex-shrink-0 group-hover:border-violet-400 transition-colors',

  avatar:
    'w-8 h-8 rounded-full flex items-center justify-center text-xs font-semibold flex-shrink-0',
  avatarIdle: 'bg-gray-100 text-gray-600 dark:bg-neutral-800 dark:text-neutral-300',
  avatarSelected: 'bg-violet-100 text-violet-700 dark:bg-violet-500/20 dark:text-violet-300',

  groupNameWrap:
    'mt-4 pt-4 border-t border-gray-200 dark:border-neutral-800',
  groupNameLabel:
    'text-sm font-medium text-gray-700 dark:text-neutral-200 mb-2',
  groupNameInput:
    'h-10 bg-white dark:bg-neutral-900 border-gray-300 dark:border-neutral-700 rounded-lg text-sm focus-visible:border-[#7C3AED]',

  empty:
    'py-10 text-center px-4',

  footer:
    'px-6 py-4 border-t border-gray-200 dark:border-neutral-800 flex items-center justify-between gap-4',
  primaryBtn:
    'relative -translate-y-px min-w-[140px] h-10 rounded-lg border border-[#6D28D9] bg-[#7C3AED] hover:bg-[#6D28D9] text-white text-sm font-semibold shadow-[0_4px_0_#5B21B6] hover:translate-y-0 hover:shadow-[0_3px_0_#5B21B6] active:translate-y-[3px] active:shadow-[0_1px_0_#5B21B6] transition-[transform,box-shadow,background-color] duration-100 disabled:translate-y-0 disabled:shadow-none disabled:opacity-50',
};
